__turbopack_context__.v({
  "zoom": "look-image-zoom-module-scss-module__Jx6qta__zoom",
});
